import { Injectable } from '@angular/core';
import { facadeFactory } from '@spartacus/core';
import { Observable } from 'rxjs';
import { BuyerData } from '../../../../core/model';
import { CART_CORE_FEATURE } from '../store/cart-state';

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: BuyerDataFacade,
      feature: CART_CORE_FEATURE,
      async: true,
      methods: ['getBuyerData'],
    }),
})
export abstract class BuyerDataFacade {
  abstract getBuyerData(cartId: string): Observable<BuyerData>;
}
